/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import type Session from 'embercom/services/session';

export default class SlackIntegrationService extends Service {
  @service declare store: Store;
  @service declare session: Session;

  @tracked existingIntegrationsIds: string[] | null = null;
  @tracked invalidAuthIntegrationIds: string[] | null = null;
  @tracked missingScopeIntegrationIds: string[] | null = null;

  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('team-omni-slack')) {
      return;
    }

    try {
      let integrations = (
        await this.store.query('slack/integration', {
          app_id: this.session.workspace.id,
        })
      ).toArray();

      this.existingIntegrationsIds = integrations.map((integration) => integration.id);
      this.invalidAuthIntegrationIds = integrations
        .filter((integration) => integration.integration_status === 'invalid_auth')
        .map((integration) => integration.id);
      this.missingScopeIntegrationIds = integrations
        .filter((integration) => integration.integration_status === 'missing_scope')
        .map((integration) => integration.id);
    } catch (error) {
      console.error('Error loading Slack integration:', error);
      this.existingIntegrationsIds = null;
      this.invalidAuthIntegrationIds = null;
      this.missingScopeIntegrationIds = null;
    }
  }

  get hasIntegrations(): boolean {
    return (this.existingIntegrationsIds?.length ?? 0) > 0;
  }

  get hasInvalidAuthIntegration(): boolean {
    return (this.invalidAuthIntegrationIds?.length ?? 0) > 0;
  }
}

declare module '@ember/service' {
  interface Registry {
    'slack-integration-service': SlackIntegrationService;
  }
}
